import React, { useEffect, useState } from "react";
import { performance } from "../../data";
import { RxSlash } from "react-icons/rx";
import Answer from "./Answer";
import Input from "../Input";

const EvaluatePerformance = ({ data, sectionRefs, formData, setFormData }) => {
  const sections = performance.sections;
  const sectionData = performance.sectionData;
  const marks = performance.marks;

  const preProcessMarks = () => {
    setFormData((prev) => ({
      ...prev,
      certifications: {
        ...prev.certifications,
        associate:
          data.certifications.associate.answer.length *
          marks.certifications.associate,
        administrator:
          data.certifications.administrator.answer.length *
          marks.certifications.administrator,
        architect:
          data.certifications.architect.answer.length *
          marks.certifications.architect,
        consultant:
          data.certifications.consultant.answer.length *
          marks.certifications.consultant,
        developer:
          data.certifications.developer.answer.length *
          marks.certifications.developer,
      },
      exercisesCompleted:
        data.exercisesCompleted.answer.length * marks.exercisesCompleted,
      isMuleSoftMeetupSpeaker: data.isMuleSoftMeetupSpeaker.answer
        ? marks.isMuleSoftMeetupSpeaker
        : 0,
      isMuleSoftMeetupLeader: data.isMuleSoftMeetupLeader.answer
        ? marks.isMuleSoftMeetupLeader
        : 0,
      isMuleSoftMentor: data.isMuleSoftMentor.answer
        ? marks.isMuleSoftMentor
        : 0,
      isMuleSoftAmbassador: data.isMuleSoftAmbassador.answer
        ? marks.isMuleSoftAmbassador
        : 0,
      completedCaeliusAIEnablementProgram: data
        .completedCaeliusAIEnablementProgram.answer
        ? marks.completedCaeliusAIEnablementProgram
        : 0,
        projectsUndertaken: data.projectsUndertaken.answer * marks.projectsUndertaken,
    }));
  };
  

  useEffect(() => {
    preProcessMarks();
  }, [marks]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const maxValue = marks[name];
    let newValue = value;
    if (newValue > maxValue) {
      newValue = maxValue;
    } else if (newValue < 0) {
      newValue = 0;
    }

    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSelfAssessmentChange = (e) => {
    const { name, value } = e.target;

    const maxValue = marks.selfAssessment;
    let newValue = value;
    if (newValue > maxValue) {
      newValue = maxValue;
    } else if (newValue < 0) {
      newValue = 0;
    }

    setFormData((prev) => ({
      ...prev,
      selfAssessment: {
        ...prev.selfAssessment,
        [name]: newValue,
      },
    }));
  };

  return (
    <div className="col-md-9">
      <div>
        {/* BEGIN: TRAINING & ENABLEMENT */}
        <section id={sections[0]} ref={sectionRefs?.[sections[0]]}>
          <div className="card">
            <h2 className="heading">{sections[0]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[0]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label htmlFor="certifications" className="question">
                  {sectionData[sections[0]].questions[0]}
                </label>
                <Answer className="performance-qa-answer-cert">
                  <div
                    id="certifications"
                    className="d-flex flex-column gap-4 width-100"
                  >
                    {/* Associate Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Associate
                        </label>
                        <div>
                          <div className="performance-item-wrapper">
                            {data.certifications.associate.answer.map(
                              (item, index) => (
                                <span
                                  className="performance-item"
                                  key={`associate-${index}`}
                                >
                                  {item}
                                </span>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                      <ComputedMarks
                        value={formData.certifications.associate}
                      />
                    </div>
                    {/* Administrator Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Administrator
                        </label>
                        <div className="performance-item-wrapper">
                          {" "}
                          {data.certifications.administrator.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`administrator-${index}`}
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                      <ComputedMarks
                        value={formData.certifications.administrator}
                      />
                    </div>
                    {/* Architect Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Architect
                        </label>
                        <div className="performance-item-wrapper">
                          {data.certifications.architect.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`architect-${index}`}
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                      <ComputedMarks
                        value={formData.certifications.architect}
                      />
                    </div>
                    {/* Consultant Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Associate
                        </label>
                        <div className="performance-item-wrapper">
                          {data.certifications.consultant.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`consultant-${index}`}
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                      <ComputedMarks
                        value={formData.certifications.consultant}
                      />
                    </div>
                    {/* Developer Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Developer
                        </label>
                        <div className="performance-item-wrapper">
                          {data.certifications.developer.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`developer-${index}`}
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                      <ComputedMarks
                        value={formData.certifications.developer}
                      />
                    </div>
                  </div>
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="otherCertifications">
                  {sectionData[sections[0]].questions[1]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.otherCertifications.answer}
                  <Marks
                    totalMarks={marks.otherCertifications}
                    name="otherCertifications"
                    onChange={handleChange}
                    value={formData.otherCertifications}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label htmlFor="exercisesCompleted" className="question">
                  {sectionData[sections[0]].questions[2]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  <div className="performance-item-wrapper">
                    {data.exercisesCompleted.answer.map((item, index) => (
                      <span
                        className="performance-item"
                        key={`exercisesCompleted-${index}`}
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                  <ComputedMarks value={formData.exercisesCompleted} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mockInterviewsGiven">
                  {sectionData[sections[0]].questions[3]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.mockInterviewsGiven.answer}{" "}
                  <Marks
                    totalMarks={marks.mockInterviewsGiven}
                    name="mockInterviewsGiven"
                    onChange={handleChange}
                    value={formData.mockInterviewsGiven}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mockInterviewDetails">
                  {sectionData[sections[0]].questions[4]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.mockInterviewDetails.answer}
                  <Marks
                    totalMarks={marks.mockInterviewDetails}
                    name="mockInterviewDetails"
                    onChange={handleChange}
                    value={formData.mockInterviewDetails}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="expertLedSessionsPresented"
                >
                  {sectionData[sections[0]].questions[5]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.expertLedSessionsPresented.answer}
                  <Marks
                    totalMarks={marks.expertLedSessionsPresented}
                    name="expertLedSessionsPresented"
                    onChange={handleChange}
                    value={formData.expertLedSessionsPresented}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="coffeeNLearnSessions">
                  {sectionData[sections[0]].questions[6]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.coffeeNLearnSessions.answer}
                  <Marks
                    totalMarks={marks.coffeeNLearnSessions}
                    name="coffeeNLearnSessions"
                    onChange={handleChange}
                    value={formData.coffeeNLearnSessions}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMeetupSpeaker">
                  {sectionData[sections[0]].questions[7]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.isMuleSoftMeetupSpeaker.answer ? "Yes" : "No"}
                  <ComputedMarks value={formData.isMuleSoftMeetupSpeaker} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="meetupDetails">
                  {sectionData[sections[0]].questions[8]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.meetupDetails.answer}
                  <Marks
                    totalMarks={marks.meetupDetails}
                    name="meetupDetails"
                    onChange={handleChange}
                    value={formData.meetupDetails}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="eventDetails">
                  {sectionData[sections[0]].questions[9]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.eventDetails.answer}
                  <Marks
                    totalMarks={marks.eventDetails}
                    name="eventDetails"
                    onChange={handleChange}
                    value={formData.eventDetails}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMeetupLeader">
                  {sectionData[sections[0]].questions[10]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.isMuleSoftMeetupLeader.answer ? "Yes" : "No"}
                  <ComputedMarks value={formData.isMuleSoftMeetupLeader} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMentor">
                  {sectionData[sections[0]].questions[11]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.isMuleSoftMentor.answer ? "Yes" : "No"}
                  <ComputedMarks value={formData.isMuleSoftMentor} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftAmbassador">
                  {sectionData[sections[0]].questions[12]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.isMuleSoftAmbassador.answer ? "Yes" : "No"}
                  <ComputedMarks value={formData.isMuleSoftAmbassador} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="salesforceSessionsPresented"
                >
                  {sectionData[sections[0]].questions[13]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.salesforceSessionsPresented.answer}
                  <Marks
                    totalMarks={marks.salesforceSessionsPresented}
                    name="salesforceSessionsPresented"
                    onChange={handleChange}
                    value={formData.salesforceSessionsPresented}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="completedCaeliusAIEnablementProgram"
                >
                  {sectionData[sections[0]].questions[14]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.completedCaeliusAIEnablementProgram.answer
                    ? "Yes"
                    : "No"}
                  <ComputedMarks
                    value={formData.completedCaeliusAIEnablementProgram}
                  />
                </Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: TRAINING & ENABLEMENT */}

        {/* BEGIN: MENTORSHIP */}
        <section id={sections[1]} ref={sectionRefs?.[sections[1]]}>
          <div className="card">
            <h2 className="heading">{sections[1]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[1]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="trainingBuddyAssisted">
                  {sectionData[sections[1]].questions[0]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.trainingBuddyAssisted.answer}
                  <Marks
                    totalMarks={marks.trainingBuddyAssisted}
                    name="trainingBuddyAssisted"
                    onChange={handleChange}
                    value={formData.trainingBuddyAssisted}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mentorLeadAssisted">
                  {sectionData[sections[1]].questions[1]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.mentorLeadAssisted.answer}
                  <Marks
                    totalMarks={marks.mentorLeadAssisted}
                    name="mentorLeadAssisted"
                    onChange={handleChange}
                    value={formData.mentorLeadAssisted}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="reviewsTaken">
                  {sectionData[sections[1]].questions[2]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.reviewsTaken.answer}
                  <Marks
                    totalMarks={marks.reviewsTaken}
                    name="reviewsTaken"
                    onChange={handleChange}
                    value={formData.reviewsTaken}
                  />
                </Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: MENTORSHIP */}

        {/* BEGIN: PROJECTS */}
        <section id={sections[2]} ref={sectionRefs?.[sections[2]]}>
          <div className="card">
            <h2 className="heading">{sections[2]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[2]].description}
              </span>
            </p>
            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="jobSkills">
                  {sectionData[sections[2]].questions[0]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.projectsUndertaken.answer}
                  <ComputedMarks value={formData.projectsUndertaken} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="projects">
                  {sectionData[sections[2]].questions[1]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.projects.answer}
                  <Marks
                    totalMarks={marks.projects}
                    name="projects"
                    onChange={handleChange}
                    value={formData.projects}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="codeReviewsTaken">
                  {sectionData[sections[2]].questions[2]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.codeReviewsTaken.answer}
                  <Marks
                    totalMarks={marks.codeReviewsTaken}
                    name="codeReviewsTaken"
                    onChange={handleChange}
                    value={formData.codeReviewsTaken}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="codeReviewsTakenArchitect">
                  {sectionData[sections[2]].questions[3]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.codeReviewsTakenArchitect.answer}
                  <Marks
                    totalMarks={marks.codeReviewsTakenArchitect}
                    name="codeReviewsTakenArchitect"
                    onChange={handleChange}
                    value={formData.codeReviewsTakenArchitect}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="architecturalSolutionsDesigned"
                >
                  {sectionData[sections[2]].questions[4]}
                </label>
                <Answer className="performance-qa-marks-answer"> 
                  {data.architecturalSolutionsDesigned.answer}
                  <Marks
                    totalMarks={marks.architecturalSolutionsDesigned}
                    name="architecturalSolutionsDesigned"
                    onChange={handleChange}
                    value={formData.architecturalSolutionsDesigned}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="achievements">
                  {sectionData[sections[2]].questions[5]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.achievements.answer}
                  <Marks
                    totalMarks={marks.achievements}
                    name="achievements"
                    onChange={handleChange}
                    value={formData.achievements}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="csatScore5Projects">
                  {sectionData[sections[2]].questions[6]}
                </label>
                <Answer className="performance-qa-marks-answer">
                  {data.csatScore5Projects.answer}
                  <Marks
                    totalMarks={marks.csatScore5Projects}
                    name="csatScore5Projects"
                    onChange={handleChange}
                    value={formData.csatScore5Projects}
                  />
                </Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: PROJECTS */}

        {/* BEGIN: GENERAL */}
        <section id={sections[3]} ref={sectionRefs?.[sections[3]]}>
          <div className="card">
            <h2 className="heading">{sections[3]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[3]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="jobSkills">
                  {sectionData[sections[3]].questions[0]}
                </label>
                <Answer>{data.selfAssessment.jobSkills.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="technicalSkills">
                  {sectionData[sections[3]].questions[1]}
                </label>
                <Answer>{data.selfAssessment.technicalSkills.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="responsiveness">
                  {sectionData[sections[3]].questions[2]}
                </label>
                <Answer>{data.selfAssessment.responsiveness.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="communicationSkills">
                  {sectionData[sections[3]].questions[3]}
                </label>
                <Answer>
                  {data.selfAssessment.communicationSkills.answer}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="teamwork">
                  {sectionData[sections[3]].questions[4]}
                </label>
                <Answer>{data.selfAssessment.teamwork.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="flexibility">
                  {sectionData[sections[3]].questions[5]}
                </label>
                <Answer>{data.selfAssessment.flexibility.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="inclusiveness">
                  {sectionData[sections[3]].questions[6]}
                </label>
                <Answer>{data.selfAssessment.inclusiveness.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiative">
                  {sectionData[sections[3]].questions[7]}
                </label>
                <Answer>{data.selfAssessment.initiative.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiativeDetails">
                  {sectionData[sections[3]].questions[8]}
                </label>
                <Answer>{data.initiativeDetails.answer}</Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: GENERAL */}

        {/* BEGIN: TRAINING REQUIREMENTS */}
        <section id={sections[4]} ref={sectionRefs?.[sections[4]]}>
          <div className="card">
            <h2 className="heading">{sections[4]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[4]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="trainingDevelopmentNeeds">
                  {sectionData[sections[4]].questions[0]}
                </label>
                <Answer>{data.trainingDevelopmentNeeds.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiative">
                  {sectionData[sections[4]].questions[1]}
                </label>
                <Answer>{data.additionalInfo.answer}</Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: TRAINING REQUIREMENTS */}
      </div>
    </div>
  );
};

const Marks = ({ totalMarks, name, onChange, value }) => {
  return (
    <div className="performance-marks-wrapper">
      <Input
        className="performance-marks-input"
        name={name}
        onChange={onChange}
        value={value}
        max={totalMarks}
        min={0}
        restrict={["space", "special", "alpha"]}
      />
      <span>
        <RxSlash />
      </span>
      <span className="performance-marks-denominator">{totalMarks}</span>
    </div>
  );
};

const ComputedMarks = ({ value }) => {
  return <span className="performance-computed-marks">{value}</span>;
};

export default EvaluatePerformance;
